import React, { Suspense } from "react"
import Gallery from "../../components/Gallery"
import Sky from "../../components/Sky"
import Artworks from "../Artworks"
import { useSpring, a } from "react-spring/three"
// import House from "../../components/House/index"
// import SkyCircle from "../../components/SkyTest"
// import Captions from "../Captions"
// import Curve from "../../components/Curve/index"
// import Diamond from "../../components/Diamond"
// import Balls from "../containers/Balls"
// import { useControl } from "react-three-gui"

const SceneObjects = (props) => {
  const { children, setLoaded, ended } = props
  // const { compensation } = useSpring({
  //   compensation: ended ? "red" : "green",
  // })
  return (
    <>
      {/* <Captions /> */}
      {/* <Balls /> */}
      {ended && <fog attach="fog" args={["black", 60, 140]} />}

      {/* <fog attach="fog" args={[colour, start, end]} /> */}
      {/* <fogExp2 attach="fog" args={["black", 0.015]} /> */}
      <Suspense fallback={null}>
        <Gallery setLoaded={setLoaded} />
        <Sky />
        {/* <House position={[0, 0, 0]} /> */}
        {/* {fogSky && <SkyCircle skyTexture={false} />} */}
        {/* <Artworks /> */}
        {/* <Diamond /> */}
        {/* <Curve/> */}
        {/* <Crater position={[0, 0, 0]} /> */}
        {children}
      </Suspense>
    </>
  )
}

export default SceneObjects
